module.exports = __webpack_public_path__ + "static/media/thermoready-3.ba5819e2.png";